module.exports = __webpack_public_path__ + "media/buy-now/sample_box7-9b84d5ca.png";